export default __webpack_public_path__ + "static/media/random_code.b481db9d.svg";